var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provider-card-skeleton"},[_c('div',{staticClass:"skeleton-image"}),_c('div',{staticClass:"skeleton-content"},[_c('div',{staticClass:"skeleton-info"},[_c('div',{staticClass:"skeleton-category"})]),_c('div',{staticClass:"skeleton-title"})])])
}]

export { render, staticRenderFns }